/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentMethodDto } from './PaymentMethodDto';
import {
    PaymentMethodDtoFromJSON,
    PaymentMethodDtoFromJSONTyped,
    PaymentMethodDtoToJSON,
} from './PaymentMethodDto';

/**
 * 
 * @export
 * @interface RefundPaymentRequest
 */
export interface RefundPaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof RefundPaymentRequest
     */
    locationId: string;
    /**
     * 
     * @type {string}
     * @memberof RefundPaymentRequest
     */
    deviceId: string;
    /**
     * 
     * @type {string}
     * @memberof RefundPaymentRequest
     */
    paymentProvider: RefundPaymentRequestPaymentProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof RefundPaymentRequest
     */
    traceId?: string;
    /**
     * 
     * @type {PaymentMethodDto}
     * @memberof RefundPaymentRequest
     */
    paymentMethod: PaymentMethodDto;
    /**
     * 
     * @type {string}
     * @memberof RefundPaymentRequest
     */
    paymentReference: string;
    /**
     * 
     * @type {string}
     * @memberof RefundPaymentRequest
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof RefundPaymentRequest
     */
    comment?: string;
}


/**
 * @export
 */
export const RefundPaymentRequestPaymentProviderEnum = {
    ADYEN: 'ADYEN',
    SOFTPAY: 'SOFTPAY',
    NETS: 'NETS'
} as const;
export type RefundPaymentRequestPaymentProviderEnum = typeof RefundPaymentRequestPaymentProviderEnum[keyof typeof RefundPaymentRequestPaymentProviderEnum];


/**
 * Check if a given object implements the RefundPaymentRequest interface.
 */
export function instanceOfRefundPaymentRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "locationId" in value;
    isInstance = isInstance && "deviceId" in value;
    isInstance = isInstance && "paymentProvider" in value;
    isInstance = isInstance && "paymentMethod" in value;
    isInstance = isInstance && "paymentReference" in value;
    isInstance = isInstance && "reason" in value;

    return isInstance;
}

export function RefundPaymentRequestFromJSON(json: any): RefundPaymentRequest {
    return RefundPaymentRequestFromJSONTyped(json, false);
}

export function RefundPaymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefundPaymentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'locationId': json['locationId'],
        'deviceId': json['deviceId'],
        'paymentProvider': json['paymentProvider'],
        'traceId': !exists(json, 'traceId') ? undefined : json['traceId'],
        'paymentMethod': PaymentMethodDtoFromJSON(json['paymentMethod']),
        'paymentReference': json['paymentReference'],
        'reason': json['reason'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function RefundPaymentRequestToJSON(value?: RefundPaymentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'locationId': value.locationId,
        'deviceId': value.deviceId,
        'paymentProvider': value.paymentProvider,
        'traceId': value.traceId,
        'paymentMethod': PaymentMethodDtoToJSON(value.paymentMethod),
        'paymentReference': value.paymentReference,
        'reason': value.reason,
        'comment': value.comment,
    };
}

